import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': {
      greet: 'Hello World',
    },
    'fr-FR': {
      greet: 'Bonjour le monde',
    },
    'ar-AE': {
      greet: 'مرحبا بالعالم',
    },
  },
});

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')
